enum NumberFormatStyle {
  CURRENCY = 'currency',
  DECIMAL = 'decimal',
}

enum DateFormats {
  SHORT_DATE = 'SHORT_DATE',
  MEDIUM_DATE = 'MEDIUM_DATE',
  LONG_DATE = 'LONG_DATE',
  FULL_DATE = 'FULL_DATE',
}

enum TimeFormats {
  SHORT_TIME = 'SHORT_TIME',
  MEDIUM_TIME = 'MEDIUM_TIME',
  LONG_TIME = 'LONG_TIME',
  FULL_TIME = 'FULL_TIME',
}

enum DateOrTime {
  DATE_ONLY = 'DATE_ONLY',
  TIME_ONLY = 'TIME_ONLY',
  DATE_AND_TIME = 'DATE_AND_TIME',
}

enum TimeZone {
  THA = 'Asia/Bangkok',
  IDN = 'Asia/Jakarta',
  JPN = 'Asia/Tokyo',
}

const DateTimeFormats: {
  [key in keyof typeof DateFormats | TimeFormats]: Intl.DateTimeFormatOptions;
} = {
  [DateFormats.SHORT_DATE]: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  },
  [TimeFormats.SHORT_TIME]: { hour: '2-digit', minute: '2-digit' },
  [DateFormats.MEDIUM_DATE]: {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  },
  [TimeFormats.MEDIUM_TIME]: {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  },
  [DateFormats.LONG_DATE]: {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  },
  [TimeFormats.LONG_TIME]: {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
  },
  [DateFormats.FULL_DATE]: {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    weekday: 'long',
  },
  [TimeFormats.FULL_TIME]: {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'long',
  },
};

export { NumberFormatStyle, DateFormats, TimeFormats, DateOrTime, DateTimeFormats, TimeZone };
